<template>
  <div :class="classes">
    <logo-icon v-if="variant === 'icon'" :dark="dark" />
    <logo-connect v-else-if="variant === 'connect'" :dark="dark" />
    <logo-family v-else-if="variant === 'family'" :dark="dark" />
    <logo-default v-else :dark="dark" />
  </div>
</template>

<script>
import { LogoDefault, LogoFamily, LogoConnect, LogoIcon } from './logos'

const logoVariants = ['default', 'icon', 'family', 'connect']
export default {
  name: 'ELogo',
  props: {
    variant: {
      type: String,
      default: 'default',
      validator: (value) => {
        return logoVariants.indexOf(value) !== -1
      },
    },
    large: Boolean,
    small: Boolean,
  },
  components: {
    LogoIcon,
    LogoFamily,
    LogoDefault,
    LogoConnect,
  },
  computed: {
    dark() {
      return this.$vuetify.theme.dark
    },
    classes() {
      return {
        'e-logo': true,
        'e-size--small': this.small,
        'e-size--large': this.large,
      }
    },
  },
}
</script>
